/**
 * Regimes tributários do db_motor_fiscal. O valor é o `codigo` do catálogo, não o id —
 * é por ele que se identificam os regimes com apuração do IRPJ (Regime Normal e Simples Nacional
 * com excesso de sublimite).
 *
 * Espelha o mesmo enum do ATS.Hub.UI.
 */
export enum RegimeTributarioEnum {
    SimplesNacional = 1,
    SimplesNacionalExcessoSublimite = 2,
    RegimeNormal = 3,
    MicroempreendedorIndividual = 4,
}
